<template>
	<div class="min-h-screen bg-gray-50">
		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 左侧导航 -->
		<aside class="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 overflow-y-auto">
			<div class="p-4 border-b border-gray-200">
				<div class="flex items-center gap-2">
					<img :src="logoUrl" alt="API文档" class="w-8 h-8 object-cover" />
					<h1 class="text-xl font-bold text-gray-800">API
						{{ $t('language000189') }}
					</h1>
				</div>
			</div>

			<el-menu default-active="1" class="el-menu-vertical-demo">
				<el-menu-item index="1" @click="toggleCategory(1)">
					<span slot="title">
						<!-- 介绍 -->
						{{ $t('language000193')}}
					</span>
				</el-menu-item>

				<el-menu-item index="8" @click="toggleCategory(8)">
					<span slot="title">
						<!-- 流程示意图 -->
						{{ $t('language000307')}}
					</span>
				</el-menu-item>

				<el-menu-item v-show="false" index="4" @click="toggleCategory(2)">
					<span slot="title">
						<!-- AES加密 -->
						{{ $t('language000226')}}
					</span>
				</el-menu-item>

				<el-menu-item index="21" @click="toggleCategory(21)">
					<span slot="title">
						<!-- 4G介绍 -->
						{{ $t('language000386')}}
					</span>
				</el-menu-item>

				<!-- 平台调用 -->
				<el-submenu index="2">
					<template slot="title">
						<span>API Service</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="1-1" @click="toggleCategory(3)">
							<!-- API Token -->
							API Token
						</el-menu-item>

						<el-menu-item index="1-3" @click="toggleCategory(11)">
							<!--刷新 API Token -->
							{{ $t('language000282') }} API Token
						</el-menu-item>

						<el-menu-item index="1-2" @click="toggleCategory(7)">
							<!-- 平台绑定设备 -->
							{{ $t('language000286') }}
						</el-menu-item>

						<el-menu-item index="2-5" @click="toggleCategory(10)">
							<!-- 查询已绑定设备信息 -->
							{{ $t('language000321')}}
						</el-menu-item>

					</el-menu-item-group>
				</el-submenu>

				<!-- 蓝牙命令 -->
				<el-submenu index="3">
					<template slot="title">
						<span slot="title">
							<!-- 蓝牙命令 -->
							{{ $t('language000395') }}
						</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="2-1" @click="toggleCategory(4)">
							<!-- 设备 Token -->
							{{ $t('language000190')}}
						</el-menu-item>

						<el-menu-item index="2-4" @click="toggleCategory(9)">
							<!-- 解密蓝牙命令 -->
							{{ $t('language000317')}}
						</el-menu-item>

						<el-menu-item index="2-2" @click="toggleCategory(5)">
							<!-- 开锁命令 -->
							{{ $t('language000191')}}
						</el-menu-item>

						<el-menu-item index="2-3" @click="toggleCategory(6)">
							<!-- 关锁命令 -->
							{{ $t('language000192')}}
						</el-menu-item>

						<el-menu-item index="2-6" @click="toggleCategory(12)">
							<!-- 定时开锁 -->
							{{ $t('language000310')}}
						</el-menu-item>

						<el-menu-item index="2-7" @click="toggleCategory(13)">
							<!-- 清除定时开锁 -->
							{{ $t('language000374')}}
						</el-menu-item>

						<el-menu-item index="2-8" @click="toggleCategory(14)">
							<!-- 定时电击 -->
							{{ $t('language000312')}}
						</el-menu-item>

						<el-menu-item index="2-9" @click="toggleCategory(15)">
							<!-- 清除定时电击 -->
							{{ $t('language000379')}}
						</el-menu-item>

						<el-menu-item index="2-10" @click="toggleCategory(16)">
							<!-- 电击一秒 -->
							{{ $t('language000380')}}
						</el-menu-item>
						
						<el-menu-item index="2-11" @click="toggleCategory(17)">
							<!-- 电击五秒 -->
							{{ $t('language000381')}}
						</el-menu-item>
						
						<el-menu-item index="2-12" @click="toggleCategory(18)">
							<!-- 停止所有电击 -->
							{{ $t('language000382')}}
						</el-menu-item>
						
						<el-menu-item index="2-13" @click="toggleCategory(19)">
							<!-- 设置屏幕方向 -->
							{{ $t('language000383')}}
						</el-menu-item>
						<el-menu-item index="2-14" @click="toggleCategory(20)">
							<!-- 设置MQTT服务 -->
							{{ $t('language000385')}}
						</el-menu-item>
						<el-menu-item index="2-15" @click="toggleCategory(22)">
							<!-- 设置工作模式 -->
							{{ $t('language000389')}}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>

				<!-- 蓝牙命令 -->
				<el-submenu index="5">
					<template slot="title">
						<span slot="title">
							<!-- 4G命令 -->
							{{ $t('language000394') }}
						</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="4-5" @click="toggleCategory(23)">
							<!-- 唤醒设备 -->
							{{ $t('language000392')}}
						</el-menu-item>

						<el-menu-item index="4-1" @click="toggleCategory(24)">
							<!-- 设备 Token -->
							{{ $t('language000190')}}
						</el-menu-item>

						<el-menu-item index="4-2" @click="toggleCategory(25)">
							<!-- 开锁命令 -->
							{{ $t('language000191')}}
						</el-menu-item>

						<el-menu-item index="4-3" @click="toggleCategory(26)">
							<!-- 关锁命令 -->
							{{ $t('language000192')}}
						</el-menu-item>

						<el-menu-item index="4-6" @click="toggleCategory(27)">
							<!-- 定时开锁 -->
							{{ $t('language000310')}}
						</el-menu-item>

						<el-menu-item index="4-7" @click="toggleCategory(28)">
							<!-- 清除定时开锁 -->
							{{ $t('language000374')}}
						</el-menu-item>

						<el-menu-item index="4-8" @click="toggleCategory(29)">
							<!-- 定时电击 -->
							{{ $t('language000312')}}
						</el-menu-item>

						<el-menu-item index="4-9" @click="toggleCategory(30)">
							<!-- 清除定时电击 -->
							{{ $t('language000379')}}
						</el-menu-item>
						
						<el-menu-item index="4-10" @click="toggleCategory(31)">
							<!-- 电击一秒 -->
							{{ $t('language000380')}}
						</el-menu-item>
						
						<el-menu-item index="4-11" @click="toggleCategory(32)">
							<!-- 电击五秒 -->
							{{ $t('language000381')}}
						</el-menu-item>
						
						<el-menu-item index="4-12" @click="toggleCategory(33)">
							<!-- 停止所有电击 -->
							{{ $t('language000382')}}
						</el-menu-item>
						
						<el-menu-item index="4-15" @click="toggleCategory(34)">
							<!-- 设置工作模式 -->
							{{ $t('language000389')}}
						</el-menu-item>

					</el-menu-item-group>
				</el-submenu>

			</el-menu>
		</aside>

		<!-- 主内容区 -->
		<main class="ml-64 p-8">
			<introduce v-show="isIntroduce" />
			<steps v-show="isSteps" />
			<Aes v-show="isAes" />
			<SubscriptionRules v-show="isSubscriptionRules" />

			<getApiToken v-show="isGetApiToken" />
			<refreshApiToken v-show="isRefreshApiToken" />
			<BindingDevice v-show="isBindingDevice" />

			<getToken v-show="isGetToken" />
			<decryptionCommand v-show="isDecryptionCommand" />
			<getUnLock v-show="isGetUnLock" />
			<getLock v-show="isGetLock" />
			<getDeviceInfo v-show="isGetDeviceInfo" />

			<getTimeUnLock v-show="isGetTimeUnLock" />
			<getTimeCellUnLock v-show="isGetTimeCellUnLock" />
			<getTimeElectricshock v-show="isGetTimeElectricshock" />
			<getTimeCellElectricshock v-show="isGetTimeCellElectricshock" />

			<getElectricshock1Second v-show="isGetElectricshock1Second" />
			<getElectricshock5Second v-show="isGetElectricshock5Second" />
			<getElectricshockStop v-show="isGetElectricshockStop" />
			<getScreenOrientation v-show="isGetScreenOrientation" />
			<setMqttService v-show="isSetMqttService" />
			<setMQTTWorkingMode v-show="isSetMQTTWorkingMode" />

			<getWakeDevice v-show="isGetWakeDevice" />
			<getToken4G v-show="isGetToken4G" />
			<getUnLock4G v-show="isGetUnLock4G" />
			<getLock4G v-show="isGetLock4G" />

			<getTimeUnLock4G v-show="isGetTimeUnLock4G" />
			<getTimeCellUnLock4G v-show="isGetTimeCellUnLock4G" />
			<getTimeElectricshock4G v-show="isGetTimeElectricshock4G" />
			<getTimeCellElectricshock4G v-show="isGetTimeCellElectricshock4G" />

			<getElectricshock1Second4G v-show="isGetElectricshock1Second4G" />
			<getElectricshock5Second4G v-show="isGetElectricshock5Second4G" />
			<getElectricshockStop4G v-show="isGetElectricshockStop4G" />
			<setMQTTWorkingMode4G v-show="isSetMQTTWorkingMode4G" />

		</main>
	</div>
</template>

<script>
	import introduce from '../gen3/item/introduce.vue'; //介绍
	import SubscriptionRules from '../current/SubscriptionRules.vue'; //4G介绍
	import steps from '../gen3/item/steps.vue'; //步骤介绍
	import Aes from '../current/Aes.vue'; //加解密

	import getApiToken from '../current/getApiToken.vue'; //获取ApiToken
	import refreshApiToken from '../current/refreshApiToken.vue'; //刷新ApiToken
	import BindingDevice from '../current/BindingDevice.vue'; //绑定设备

	import getToken from '../gen3/item/getToken.vue'; //获取token
	import decryptionCommand from '../gen3/item/decryptionCommand.vue'; //解密蓝牙命令
	import getUnLock from '../gen3/item/getUnLock.vue'; //获取开锁命令
	import getLock from '../gen3/item/getLock.vue'; //获取关锁命令
	import getDeviceInfo from '../current/getDeviceInfo.vue'; //查询设备信息

	import getTimeUnLock from '../gen3/item/getTimeUnLock.vue'; //获取定时开锁命令
	import getTimeCellUnLock from '../gen3/item/getTimeCellUnLock.vue'; //获取清除定时开锁命令
	import getTimeElectricshock from '../gen3/item/getTimeElectricshock.vue'; //获取定时电击
	import getTimeCellElectricshock from '../gen3/item/getTimeCellElectricshock.vue'; //获取清除定时电击

	import getElectricshock1Second from '../gen3/item/getElectricshock1Second.vue'; //电击一秒
	import getElectricshock5Second from '../gen3/item/getElectricshock5Second.vue'; //电击五秒
	import getElectricshockStop from '../gen3/item/getElectricshockStop.vue'; //停止所有电击
	import getScreenOrientation from '../gen3/item/getScreenOrientation.vue'; //设置屏幕方向
	import setMqttService from '../gen3/item/setMqttService.vue'; //设置MQTT服务
	import setMQTTWorkingMode from '../gen3/item/setMQTTWorkingMode.vue'; //设置4G工作模式

	import getWakeDevice from '../gen3/4g/getWakeDevice.vue'; //唤醒设备
	import getToken4G from '../gen3/4g/getToken.vue'; //获取token
	import getUnLock4G from '../gen3/4g/getUnLock.vue'; //获取开锁命令
	import getLock4G from '../gen3/4g/getLock.vue'; //获取关锁命令

	import getTimeUnLock4G from '../gen3/4g/getTimeUnLock.vue'; //获取定时开锁命令
	import getTimeCellUnLock4G from '../gen3/4g/getTimeCellUnLock.vue'; //获取清除定时开锁命令
	import getTimeElectricshock4G from '../gen3/4g/getTimeElectricshock.vue'; //获取定时电击
	import getTimeCellElectricshock4G from '../gen3/4g/getTimeCellElectricshock.vue'; //获取清除定时电击

	import getElectricshock1Second4G from '../gen3/4g/getElectricshock1Second.vue'; //电击一秒
	import getElectricshock5Second4G from '../gen3/4g/getElectricshock5Second.vue'; //电击五秒
	import getElectricshockStop4G from '../gen3/4g/getElectricshockStop.vue'; //停止所有电击
	import setMQTTWorkingMode4G from '../gen3/4g/setMQTTWorkingMode.vue'; //设置4G工作模式

	export default {
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 设置语言
		},
		components: {
			introduce,
			steps,
			Aes,
			getApiToken,
			refreshApiToken,
			BindingDevice,
			getToken,
			decryptionCommand,
			getUnLock,
			getLock,
			getDeviceInfo,
			getTimeUnLock,
			getTimeCellUnLock,
			getTimeElectricshock,
			getTimeCellElectricshock,
			getElectricshock1Second,
			getElectricshock5Second,
			getElectricshockStop,
			getScreenOrientation,
			setMqttService,
			SubscriptionRules,
			setMQTTWorkingMode,
			getWakeDevice,
			getToken4G,
			getUnLock4G,
			getLock4G,
			getTimeUnLock4G,
			getTimeCellUnLock4G,
			getTimeElectricshock4G,
			getTimeCellElectricshock4G,
			getElectricshock1Second4G,
			getElectricshock5Second4G,
			getElectricshockStop4G,
			setMQTTWorkingMode4G,
		},
		computed: {},
		data() {
			return {
				isIntroduce: true,
				isSteps: false,
				isAes: false,
				isGetApiToken: false,
				isRefreshApiToken: false,
				isBindingDevice: false,
				isGetToken: false,
				isDecryptionCommand: false,
				isGetUnLock: false,
				isGetLock: false,
				isGetDeviceInfo: false,
				isGetTimeUnLock: false,
				isGetTimeCellUnLock: false,
				isGetTimeElectricshock: false,
				isGetTimeCellElectricshock: false,
				isGetElectricshock1Second: false,
				isGetElectricshock5Second: false,
				isGetElectricshockStop: false,
				isGetScreenOrientation: false,
				isSetMqttService: false,
				isSubscriptionRules: false,
				isSetMQTTWorkingMode: false,
				isGetWakeDevice: false,
				isGetToken4G: false,
				isGetUnLock4G: false,
				isGetLock4G: false,
				isGetTimeUnLock4G: false,
				isGetTimeCellUnLock4G: false,
				isGetTimeElectricshock4G: false,
				isGetTimeCellElectricshock4G: false,
				isGetElectricshock1Second4G: false,
				isGetElectricshock5Second4G: false,
				isGetElectricshockStop4G: false,
				isSetMQTTWorkingMode4G: false,
				logoUrl: require('../../../../assets/app_logo.jpg'),
			};
		},
		methods: {
			toggleCategory(index) {
				this.isIntroduce = index === 1;
				this.isAes = index === 2;
				this.isGetApiToken = index === 3;
				this.isGetToken = index === 4;
				this.isGetUnLock = index === 5;
				this.isGetLock = index === 6;
				this.isBindingDevice = index === 7;
				this.isSteps = index === 8;
				this.isDecryptionCommand = index === 9;
				this.isGetDeviceInfo = index === 10;
				this.isRefreshApiToken = index === 11;
				this.isGetTimeUnLock = index === 12;
				this.isGetTimeCellUnLock = index === 13;
				this.isGetTimeElectricshock = index === 14;
				this.isGetTimeCellElectricshock = index === 15;
				this.isGetElectricshock1Second = index === 16;
				this.isGetElectricshock5Second = index === 17;
				this.isGetElectricshockStop = index === 18;
				this.isGetScreenOrientation = index === 19;
				this.isSetMqttService = index === 20;
				this.isSubscriptionRules = index === 21;
				this.isSetMQTTWorkingMode = index === 22;
				this.isGetWakeDevice = index === 23;
				this.isGetToken4G = index === 24;
				this.isGetUnLock4G = index === 25;
				this.isGetLock4G = index === 26;
				this.isGetTimeUnLock4G = index === 27;
				this.isGetTimeCellUnLock4G = index === 28;
				this.isGetTimeElectricshock4G = index === 29;
				this.isGetTimeCellElectricshock4G = index === 30;
				this.isGetElectricshock1Second4G = index === 31;
				this.isGetElectricshock5Second4G = index === 32;
				this.isGetElectricshockStop4G = index === 33;
				this.isSetMQTTWorkingMode4G = index === 34;


				window.scrollTo(0, 0); // 切换时回到顶部

			},
			//...
		},
	};
</script>

<style scoped>
</style>